import { render, staticRenderFns } from "./ClassEES7Star.vue?vue&type=template&id=6b5488fa&"
import script from "./ClassEES7Star.vue?vue&type=script&lang=ts&"
export * from "./ClassEES7Star.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports